import { connect } from 'react-redux';
import AppSiteSelection from '../components/AppSiteSelection';
import { getAppSiteSelectionPage } from '../selectors';
import { addFutureChanged, changeAppSiteSelection } from '../actions';

const mapStateToProps = state => getAppSiteSelectionPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onChange: (ids, value) => dispatch(changeAppSiteSelection(ids, value)),
        enableAddFuture: () => dispatch(addFutureChanged('app_site_id', true, true)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AppSiteSelection);
